/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3ProposalsProposalIdDeadlineExtensionsRequest = {
  proposalId: number;
};

/** @internal */
export const GetApiV3ProposalsProposalIdDeadlineExtensionsRequest$inboundSchema:
  z.ZodType<
    GetApiV3ProposalsProposalIdDeadlineExtensionsRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    proposal_id: z.number().int(),
  }).transform((v) => {
    return remap$(v, {
      "proposal_id": "proposalId",
    });
  });

/** @internal */
export type GetApiV3ProposalsProposalIdDeadlineExtensionsRequest$Outbound = {
  proposal_id: number;
};

/** @internal */
export const GetApiV3ProposalsProposalIdDeadlineExtensionsRequest$outboundSchema:
  z.ZodType<
    GetApiV3ProposalsProposalIdDeadlineExtensionsRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3ProposalsProposalIdDeadlineExtensionsRequest
  > = z.object({
    proposalId: z.number().int(),
  }).transform((v) => {
    return remap$(v, {
      proposalId: "proposal_id",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ProposalsProposalIdDeadlineExtensionsRequest$ {
  /** @deprecated use `GetApiV3ProposalsProposalIdDeadlineExtensionsRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3ProposalsProposalIdDeadlineExtensionsRequest$inboundSchema;
  /** @deprecated use `GetApiV3ProposalsProposalIdDeadlineExtensionsRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3ProposalsProposalIdDeadlineExtensionsRequest$outboundSchema;
  /** @deprecated use `GetApiV3ProposalsProposalIdDeadlineExtensionsRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3ProposalsProposalIdDeadlineExtensionsRequest$Outbound;
}

export function getApiV3ProposalsProposalIdDeadlineExtensionsRequestToJSON(
  getApiV3ProposalsProposalIdDeadlineExtensionsRequest:
    GetApiV3ProposalsProposalIdDeadlineExtensionsRequest,
): string {
  return JSON.stringify(
    GetApiV3ProposalsProposalIdDeadlineExtensionsRequest$outboundSchema.parse(
      getApiV3ProposalsProposalIdDeadlineExtensionsRequest,
    ),
  );
}

export function getApiV3ProposalsProposalIdDeadlineExtensionsRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3ProposalsProposalIdDeadlineExtensionsRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3ProposalsProposalIdDeadlineExtensionsRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3ProposalsProposalIdDeadlineExtensionsRequest' from JSON`,
  );
}
